import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Get user's first name from full name
 */
export const getFirstName = (fullName?: string, shortName?: string): string => {
  if (shortName) return shortName;
  if (!fullName) return 'User';
  return fullName.split(' ')[0];
};

/**
 * Get initials from name (first letter only)
 */
export const getInitial = (name?: string): string => {
  if (!name) return 'U';
  return name.charAt(0).toUpperCase();
};
